/** Anchor trên /workspace để điều hướng tới từng khối nội dung (không dùng tab). */
export const WORKSPACE_SECTION_IDS = {
  tongQuan: 'section-tong-quan',
  quanTri: 'section-quan-tri',
  vanBanChoKy: 'section-van-ban-cho-ky',
  quyetDinhThamQuyen: 'section-quyet-dinh-tham-quyen',
  phanCongAn: 'section-phan-cong-an',
  vuAnCuaToi: 'section-vu-an-cua-toi',
  danhSachAn: 'section-danh-sach-an',
  lichLamViec: 'section-lich-lam-viec',
} as const

export function workspaceHash(id: (typeof WORKSPACE_SECTION_IDS)[keyof typeof WORKSPACE_SECTION_IDS]) {
  return `/workspace#${id}`
}
